import type { ReactNode } from 'react';

// جهت نمایش badge در جدول
type BadgeRendererProps = {
  text?: ReactNode;
  color?: string;
  textColor?: string;
};

const BadgeRenderer = ({
  text,
  color,
  textColor = 'inherit'
}: BadgeRendererProps) => {
  return (
    <div className="w-100 d-flex justify-content-center ">
      <div>
        <span
          style={{ backgroundColor: color, color: textColor }}
          className={`px-2 h-auto py-1 rounded-2 fs--2 ${textColor === 'inherit' && 'text-light'}`}
        >
          {text}
        </span>
      </div>
    </div>
  );
};

export default BadgeRenderer;
